import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Container = styled.div`
  .button {
    padding: 0;
    margin: 0;

    background: none;
    border: 0;

    color: ${({ theme }) => (theme.isDark ? '#C6C6C6' : '#5E6871')};

    position: relative;

    width: 32px;
    height: 32px;

    .icon {
      position: absolute;

      width: 100%;
      height: 100%;

      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      transition: opacity 0.3s ease;

      &[data-is-visible='true'] {
        opacity: 1;
      }

      &[data-is-visible='false'] {
        opacity: 0;
      }
    }
  }

  @media only screen and (min-width: 1000px) {
    position: relative;
  }
`

export const Drawer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;

  width: min(234px, 94vw);

  z-index: 30;

  transition: all 0.3s ease;

  border-right: 1px solid ${({ theme }) => (theme.isDark ? '#4B4B4B' : '#D9D9D9')};

  background-color: ${({ theme }) => (theme.isDark ? '#222222' : '#fff')};

  &[data-is-open='false'] {
    transform: translateX(-100%);
  }

  padding-top: 16px;

  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 1000px) {
    display: none;
  }
`

export const Overlay = styled.div`
  background-color: #222222cc;

  position: fixed;
  inset: 0;

  z-index: 10;

  transition: opacity 0.3s ease;

  &[data-is-visible='false'] {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
  }

  @media only screen and (min-width: 1000px) {
    display: none;
  }
`

export const Dropdown = styled.div`
  display: none;

  @media only screen and (min-width: 1000px) {
    position: absolute;
    bottom: 0;
    transform: translateY(calc(100% + 6px));

    min-width: 231px;

    padding-top: 16px;
    padding-bottom: 6px;

    display: flex;
    flex-direction: column;

    border: 1px solid ${({ theme }) => (theme.isDark ? '#4B4B4B' : '#D9D9D9')};
    border-radius: 4px;

    background-color: ${({ theme }) => (theme.isDark ? '#222222' : '#fff')};

    z-index: 30;

    transition: opacity 0.3s ease;

    &[data-is-open='false'] {
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
    }
  }
`

export const RouteLink = styled(Link)`
  padding: 16px 24px;

  color: ${({ theme }) => (theme.isDark ? '#fff' : '#4A4A4A')};

  font-size: 16px;
  font-weight: 700;
  line-height: 21px;

  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;

  .icon {
    flex-shrink: 0;
  }
`
